import classNames from "classnames";
import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { Sounds } from "../../../../services/Sound/Sounds";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "../../Link/Hyperlink";
import Render from "../../Render";
import RPGIcon from "../../RPGIcon/RPGIcon";
import { dynamicOpacityFormClass, sharedFormStyleClass } from "../Form";
import * as formStyles from "../Form.css";
import { IFormTextAreaProps } from "./IFormTextAreaProps";

export function FormTextArea(props: IFormTextAreaProps) {
    const textAreaRef = React.useRef<any>(null);

    const AutoAdjustHeight = () => {
        const scrollHeight = textAreaRef.current.scrollHeight;
        const newHeight = props.value && props.value.length ? scrollHeight : 32;
        textAreaRef.current.style.height = `${newHeight}px`;
    };

    React.useEffect(() => AutoAdjustHeight(), [props.value]);

    return (
        <span
            className={classNames(formStyles.main, {
                [formStyles.hidden]: props.readonly || false,
            })}
        >
            <Render
                id="iconLabel"
                when={props.iconSuffix}
                withClasses={classNames(
                    formStyles.label,
                    formStyles.textAreaLabel
                )}
            >
                <RPGIcon
                    icon={props.iconSuffix!}
                    withClass={formStyles.labelIcon}
                />
            </Render>
            <Render
                id="textLabel"
                when={props.label}
                withClasses={classNames(
                    formStyles.label,
                    formStyles.textAreaLabel
                )}
            >
                {props.label}
            </Render>
            <textarea
                id={props.id}
                rows={1}
                onChange={(event) => {
                    props.onChange(event.target.value);
                }}
                onClick={(event: any) => {
                    Sounds.ambientHalo.Play();
                    AutoAdjustHeight();

                    props.onClick
                        ? props.onClick(event.target.value)
                        : () => {};
                }}
                value={props.value}
                style={{
                    width: props.width,
                    minWidth: props.minWidth,
                    maxWidth: props.maxWidth,
                    ...props.styles,
                }}
                className={classNames(
                    props.classes,
                    [formStyles.formControl, formStyles.noScrollBar],
                    {
                        [formStyles.formControlAnimations]: !IsMobileDevice(),
                    },
                    sharedFormStyleClass,
                    { [dynamicOpacityFormClass]: props.dynamicOpacity }
                )}
                onKeyDown={async (event) => {
                    if (props.onKeyDown) {
                        props.onKeyDown(event);
                    }

                    if (
                        event.key === "Enter" &&
                        props.onEnter &&
                        !event.shiftKey
                    ) {
                        props.onEnter(props.value);
                        event.preventDefault();
                    }
                }}
                readOnly={props.readonly}
                ref={textAreaRef}
                placeholder={props.placeholder}
            />
            <Render
                id="pressEnterLabel"
                when={props.onEnter && props.value && !props.hideEnterIcon}
                withClasses={formStyles.pressEnterLabelTextArea}
            >
                ↵
            </Render>
            <Render id="clearInputIcon" when={props.onClear !== undefined}>
                <Hyperlink
                    classes={formStyles.clearTextAreaInput}
                    whenClicked={() => (props.onClear ? props.onClear() : {})}
                >
                    <Glyphicon icon={EGlyphicon["remove"]} />
                </Hyperlink>
            </Render>
        </span>
    );
}
